// Headset shell (RealityAgent/hmdagent) versions for the Software page's
// desired-version dropdown. The shell is not a GitHub-released component: the
// agent release workflow publishes the committed APK to the public software
// bucket under hmd_shell/<version>/ and keeps a 'latest' text pointer next to
// it (the same layout the agent's own tokenless updater uses). Only 'latest'
// is offered; older versions go through "Custom…". Best-effort: [] on any
// failure, like the GitHub-backed lists.
const SUPABASE_URL: string = import.meta.env.VITE_SUPABASE_URL;

export async function fetchShellVersions(): Promise<string[]> {
  try {
    const res = await fetch(`${SUPABASE_URL}/storage/v1/object/public/software/hmd_shell/latest`, { cache: 'no-store' });
    if (!res.ok) return [];
    const v = (await res.text()).trim().replace(/^v/, '');
    return /^\d+\.\d+\.\d+$/.test(v) ? [v] : [];
  } catch (err) {
    console.warn('Could not fetch headset shell versions:', err);
    return [];
  }
}
